import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 128 128"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F0F0F0",
      d: "M64 128c35.346 0 64-28.654 64-64S99.346 0 64 0 0 28.654 0 64s28.654 64 64 64"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D80027",
      d: "M58.432 64s-39.652 45.264-39.69 45.255C30.324 120.837 46.324 128 63.997 128c35.346 0 64-28.654 64-64z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0052B4",
      d: "M18.745 18.744c-24.993 24.994-24.993 65.516 0 90.51L64 63.999z"
    }, null, -1)
  ])))
}
export default { render: render }